import { BrandLanguage } from "entities/brands/languages/type";

export type SettingsRow = {
  title: string;
  modulesCount: number;
  updatedAt: Date;
  status: boolean;
};

export type SettingsTableData = {
  data: SettingsRow[];
};

export type BrandSettingsColumnsProps = {
  handleOpenSettingDetailPage: (id: string) => void;
};

export enum SettingsTabs {
  SEARCH = "search",
  LANGUAGES = "languages",
  MAINTENANCE_MODE = "maintenance_mode",
}

export type ExtendedBrandLanguage = BrandLanguage & {
  generalAssistantId?: string;
  gameNameAssistantId?: string;
};
